export default __webpack_public_path__ + "static/media/btn-youtube.b179887f.png";